// @flow strict

// $FlowFixMe[nonstrict-import]
import type {SenseAction} from 'src/action-creators/types';
// $FlowFixMe[nonstrict-import]
import type {LanguageTranslationKeyAndValue} from 'src/types/messages';
import invert from 'lodash/invert';

import {
  RECEIVE_ALL_SUPPORTED_LANGUAGES,
  SET_CANDIDATE_LANG_CODE,
} from 'src/action-creators/chat/language-translation';


export type State = {
  languages: LanguageTranslationKeyAndValue,
  languageCodeToNameMapping: LanguageTranslationKeyAndValue,
  candidateLanguages: LanguageTranslationKeyAndValue,
};

const initialState = {
  languages: {},
  languageCodeToNameMapping: {},
  candidateLanguages: {},
};

export default function reduce(
  state: State = initialState,
  action: SenseAction,
): State {
  switch (action.type) {
    case RECEIVE_ALL_SUPPORTED_LANGUAGES: {
      return {
        ...state,
        languages: action.payload,
        languageCodeToNameMapping: invert(action.payload),
      };
    }
    case SET_CANDIDATE_LANG_CODE: {
      return {
        ...state,
        candidateLanguages: {
          ...state.candidateLanguages,
          [action.payload.id]: action.payload.langCode,
        },
      };
    }

    default:
      return state;
  }
}
